export default __webpack_public_path__ + "static/media/Spiderman2_07.40bd2159.png";